import React, { Component } from "react";

class Forms extends Component {
  componentWillMount() {
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <div className="forms">
        <div className="forms__container">
          <div className="forms__container__item">
            <h3>Order Forms</h3>
            <p>
              <span>1.</span> Simply print off the order forms and fill out your
              information <br />
              All information that you provide to Universal Drugstore will be
              kept strictly confidential. <br /> Please view our privacy policy.
            </p>
            <a href="./assets/Order-Form.pdf" download>
              {" "}
              <i className="fas fa-download" /> PDF Order Forms
            </a>
            <br />
            <a href="./assets/Pre-Authorized-Payment.pdf" download>
              {" "}
              <i className="fas fa-download" />
              Pre-Authorized Payment Form
            </a>
            <p style={{ fontWeight: 300, fontStyle: "italic" }}>
              PDF files require Adobe Acroboat Reader. Download a free copy{" "}
              <a
                className="forms__container__item--simpleDownload"
                href="https://get.adobe.com/reader/"
              >
                here
              </a>
            </p>
          </div>
          <div className="forms__container__item">
            <p>
              <span>2.</span> Send us your information <br /> Simply mail the
              forms back to us, or fax them back to us toll-free at
              1-586-630-3029. <br /> Please remember to include your valid
              prescription with the questionnaire and release form.
            </p>
          </div>
        </div>
        <img src="./assets/3.jpg" alt="" />
      </div>
    );
  }
}

export default Forms;



// WEBPACK FOOTER //
// ./src/components/Forms/Forms.js